/**
 * PASSWORD
 */

export const PASSWORD_FIELD_NAME = {
  // current password field name
  CURRENT: 'CURRENT',
  // new password field name
  NEW: 'newPassword',
  // confirm new password field name
  NEW_CONFIRM: 'confirmNewPassword',
};

// special characters (used is translation as description)
export const SPECIAL_CHARS_PASSWORD = '0123456789!#$%&()*+,.:;<>=?@^_{|}][';
// max character length for password
export const MAX_PASSWORD_LENGTH = 128;
// min character length for password
export const MIN_PASSWORD_LENGTH = 6;

export const REQUEST_ERROR_STATUS = {
  ACCOUNT_DELETED: 'ACCOUNT_DELETED',
  // the password and the username are the same
  PASSWORD_SAME_AS_USERNAME: 'PASSWORD_SAME_AS_USERNAME',
  // the provided password is invalid
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  // error 400 new and current password are the same
  NEW_PASSWORD_SAME_AS_CURRENT: 'NEW_PASSWORD_SAME_AS_CURRENT',
  // error 403 currentPassword doesn't match the actual password
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  // error 403 twofa required (if this error status is received it will call side effect action to trigger two fa modal)
  TWO_FA_REQUIRED: 'TWO_FA_REQUIRED',
  UNVERIFIED_USER: 'UNVERIFIED_USER',
  CLIENT_BANNED: 'CLIENT_BANNED',
  REQUIRES_CAPTCHA: 'REQUIRES_CAPTCHA',
  INVALID_CAPTCHA: 'INVALID_CAPTCHA',
  ACCOUNT_EXPIRED: 'ACCOUNT_EXPIRED',
  SECURITY_QUESTION_REQUIRED: 'SECURITY_QUESTION_REQUIRED',
  INVALID_OR_EXPIRED_TOKEN: 'INVALID_OR_EXPIRED_TOKEN',
  INVALID_OR_EXPIRED_TWO_FA_CODE: 'INVALID_OR_EXPIRED_TWO_FA_CODE',
  OPERATION_ALREADY_VALIDATED: 'OPERATION_ALREADY_VALIDATED',
  TWO_FA_LIMIT_REACHED: 'TWO_FA_LIMIT_REACHED',
};

export const FIELD_VALIDATION_STATUS = {
  // when field is empty
  IS_EMPTY: 'IS_EMPTY',
  // when comparing 2 input values
  DO_NOT_MATCH: 'DO_NOT_MATCH',
  // when lowercase character is missing
  INVALID_PASSWORD_LOWERCASE: 'INVALID_PASSWORD_LOWERCASE',
  // when uppercase character is missing
  INVALID_PASSWORD_UPPERCASE: 'INVALID_PASSWORD_UPPERCASE',
  // when number or symbol is missing SPECIAL_CHARS_PASSWORD
  INVALID_PASSWORD_NUMBER_OR_SYMBOL: 'INVALID_PASSWORD_NUMBER_OR_SYMBOL',
  // when password length doesn't matches MAX_PASSWORD_LENGTH or MIN_PASSWORD_LENGTH
  INVALID_PASSWORD_LENGTH: 'INVALID_PASSWORD_LENGTH',
  // when password field contains illegal characters
  ILLEGAL_PASSWORD_CHARACTERS: 'ILLEGAL_PASSWORD_CHARACTERS',
};

export const INVALID_PASSWORD_LOWERCASE_REGEX = /(?=.*[a-z])/;
export const INVALID_PASSWORD_UPPERCASE_REGEX = /(?=.*[A-Z])/;
export const INVALID_PASSWORD_NUMBER_OR_SYMBOL_REGEX = /(?=.*[!#$%&()*+,.:;<>=?@^_{|}[\]0-9])/;
export const PASSWORD_ILLEGAL_CHARS_REGEX = /^(?=.*^[!#$%&()*+,.:;<>=?@^_{|}[\]0-9a-zA-Z]+$).{6,128}$/;

export const ERROR_MESSAGE_TRANSLATION_KEYS = {
  [REQUEST_ERROR_STATUS.PASSWORD_SAME_AS_USERNAME]: ['profile.change.password.jsp.1'],
  [REQUEST_ERROR_STATUS.NEW_PASSWORD_SAME_AS_CURRENT]: ['profile.profile.password.error.same.as.current'],
  [REQUEST_ERROR_STATUS.INVALID_CREDENTIALS]: ['android.toast_invalid_credentials'],
  [REQUEST_ERROR_STATUS.INVALID_PASSWORD]: ['android.toast_invalid_credentials'],
  [FIELD_VALIDATION_STATUS.DO_NOT_MATCH]: ['account.security.managePassword.doNotMatch'],
  [FIELD_VALIDATION_STATUS.INVALID_PASSWORD_LENGTH]: [
    'profile.profile.password.error.length',
    { 0: MIN_PASSWORD_LENGTH, 1: MAX_PASSWORD_LENGTH },
  ],
  [FIELD_VALIDATION_STATUS.INVALID_PASSWORD_LOWERCASE]: ['profile.profile.password.error.lowercase'],
  [FIELD_VALIDATION_STATUS.INVALID_PASSWORD_UPPERCASE]: ['profile.profile.password.error.uppercase'],
  [FIELD_VALIDATION_STATUS.INVALID_PASSWORD_NUMBER_OR_SYMBOL]: [
    'profile.profile.password.error.specialchar',
    { 0: SPECIAL_CHARS_PASSWORD },
  ],
  [FIELD_VALIDATION_STATUS.ILLEGAL_PASSWORD_CHARACTERS]: ['profile.profile.password.error.illegal'],
};

export const PASSWORD_FIELD_TRANSLATION_KEYS = {
  [PASSWORD_FIELD_NAME.CURRENT]: ['account.security.managePassword.enterCurrent'],
  [PASSWORD_FIELD_NAME.NEW]: ['account.security.managePassword.enterNew'],
  [PASSWORD_FIELD_NAME.NEW_CONFIRM]: ['account.security.managePassword.reEnterNew'],
};

/**
 * LOGIN
 */

export const loginRedirectionErrors = [
  REQUEST_ERROR_STATUS.UNVERIFIED_USER,
  REQUEST_ERROR_STATUS.ACCOUNT_EXPIRED,
  REQUEST_ERROR_STATUS.SECURITY_QUESTION_REQUIRED,
  REQUEST_ERROR_STATUS.TWO_FA_REQUIRED,
];

/**
 * REGISTRATION
 */

/**
 * 2FA
 */

/**
 * UTILITY FUNCTIONS
 */
